import Plot from "react-plotly.js";
import { Layout } from "plotly.js";
import * as d3 from "d3";
import "plotly.js/dist/plotly-locale-de";


interface BarChartProps {
    freqData : { locationId: string, frequency: number, count: number }[]
}

const ScheduleBasedTherapyRxPlot: React.FC<BarChartProps> = ({freqData}) => {
    const groupedData = Object.groupBy(freqData, ({ frequency }) => frequency);
    
    const traces: Plotly.Data[] = [];
    const numCategories = Object.keys(groupedData).length
    const colorPalette = d3.scaleOrdinal(d3['schemeTableau10']).range().slice(0, numCategories);

    Object.keys(groupedData).forEach((frequency, index) => {
        const color = colorPalette[index % colorPalette.length];

        const trace: Plotly.Data = {
            x: groupedData[Number(frequency)]?.map(entry => entry.locationId),
            y: groupedData[Number(frequency)]?.map(entry => entry.count), 
            type: 'bar',
            marker: {
                color: color,
                width: 0.5,
            },
            name: frequency,
            // hoverinfo: "y+name",
            hovertemplate: "%{y:,.1f} %",
        };

        traces.push(trace);
    });

    const layout: Partial<Layout> = {
        height: 400,
        autosize: true,
        barmode: "stack",
        barnorm: "percent",
        bargap: 0.75,
        xaxis: {
            tickfont: {
                family: 'Roboto', 
                size: 12,
            },
            showgrid: false,
            zeroline: false,
        },
        yaxis: {
            title: {
                text: '%',
                font: {
                    family: 'Roboto', 
                    size: 14,
                },
                standoff: 1,
            },
            tickmode: 'auto',
            tickfont: {
                family: 'Roboto', 
                size: 12,
            },
            griddash: 'dot',
            rangemode: 'tozero',
            zeroline: true,
            zerolinecolor: 'rgb(204, 204, 204)',
            linecolor: 'rgb(204, 204, 204)',
            gridcolor: 'rgb(204, 204, 204)',
        },
        showlegend: true,
        legend: {
            orientation: 'h',
            x: 0.5,
            xanchor: 'center',
            font: {
                family: 'Roboto',
                size: 12,
            },
            traceorder: "normal",
        },
        hoverlabel: {
            font: {
                family: 'Roboto',
                size: 12,
            }
        },
        margin: {
            t: 40, 
            b: 50, 
            l: 50, 
            r: 50, 
        },
        modebar: {
            orientation: 'v'
        }
    }

    return <Plot data={traces} layout={layout} config={{ locale: 'de' }} useResizeHandler={true} style={{ width: "100%", height: "100%" }} />;
}

export default ScheduleBasedTherapyRxPlot;